
import { useState, useEffect, useCallback } from 'react';
import { useFetchData } from 'hooks/apiHooks';
import { createGradient } from 'utils';

const useHistogramData = (apiEndpoint, initialCategory, processDataForChart) => {
    const { data, isLoading, error, refetch } = useFetchData(apiEndpoint);
    const [category, setCategory] = useState(initialCategory);
    const [gradientStroke, setGradientStroke] = useState(null);

    const createGradientStroke = useCallback(() => {
        const ctx = document.createElement('canvas').getContext('2d');
        const gradient = createGradient(ctx, { left: 0, right: 100, top: 0, bottom: 100 }, ["rgba(29,140,248,0.2)", "rgba(29,140,248,0)"]);
        setGradientStroke(gradient);
    }, []);

    useEffect(() => {
        createGradientStroke();
    }, [createGradientStroke]);

    const chartData = processDataForChart(data, category);

    return { chartData, isLoading, error, refetch, category, setCategory, gradientStroke };
};

export default useHistogramData;